import { render } from "./Bar.vue?vue&type=template&id=1fbee8bc&scoped=true"
import script from "./Bar.vue?vue&type=script&lang=js"
export * from "./Bar.vue?vue&type=script&lang=js"

import "./Bar.vue?vue&type=style&index=0&id=1fbee8bc&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbee8bc"]])

export default __exports__